import { Checkbox } from 'flowbite-react';
import React, { useContext, useEffect, useState } from 'react';
import client from '../../../../api/client';
import showToast from '../../../../components/CustomToast/toastHelper';
import { UserContext } from '../../../../contexts/UserContext';

const Preferences = () => {
    const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
    const [feeBearer, setFeeBearer] = useState<any[]>([
        { value: 'SBF', description: 'Charge me the transaction fees' },
        { value: 'CBF', description: 'Charge my customers the transaction fees' },
        { value: 'SPLIT', description: 'Split the transaction fees' }
    ]);
    const [currentBearer, setCurrentBearer] = useState<any>();
    const [twoFaStatus, setTwoFaStatus] = useState<any>({});
    const [emailPreferences, setEmailPreferences] = useState({
        allowCustomerTransactionEmails: false,
        allowMerchantTransactionEmails: false
    });
    const [sendLoginNotification, setSendLoginNotification] = useState<boolean>(false)
    const [transactionEmailStatuses, setTransactionEmailStatuses] = useState<any>(null);
    const { userDetails } = useContext(UserContext) ?? {}

    const { activeSubsidiary, envronmentDetail, user } = userDetails


    useEffect(() => {
        const fetchData = async () => {
            await fetchFeeBearer();
            await fetchPaymentMethods();
            await fetch2faLoginStatus();
            await fetchEmailTransationStatus();
            await fetchSendLoginNotificationStatus()
        };
        fetchData();
    }, []);

    const fetchFeeBearer = async () => {
        try {
            const response = await client.get('subsidiary/dashboard/payment/fees/view');
            const message = response?.data?.message;
            setCurrentBearer(response.data.data);
            // showToast(message, 'success');
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };

    const setPaymentFeeBearer = async (bearer: string) => {
        const payload = {
            feeBearer: bearer
        };
        try {
            const response = await client.post('/subsidiary/dashboard/payment/fees/set', payload);
            const message = response?.data?.message;
            showToast(message, 'success');
            fetchFeeBearer();
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };

    const setPaymentMethod = async (paymentMethod: string, type: string) => {
        const payload = {
            paymentOption: paymentMethod
        };
        try {
            const response = await client.post(`/subsidiary/dashboard/payment/options/${type}`, payload);
            const message = response?.data?.message;
            showToast(message, 'success');
            fetchPaymentMethods();
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };

    const fetchPaymentMethods = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/payment/options/view');
            setPaymentMethods(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    };


    const fetch2faLoginStatus = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/2fa/login/view');
            setTwoFaStatus(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    };



    const fetchEmailTransationStatus = async () => {
        try {
            const response = await client.post('/subsidiary/dashboard/users/email/transaction/status', {
                subsidiaryId: activeSubsidiary?.id,
                enviromentId: envronmentDetail?.id,
            });
            const data = response.data.data;
            setTransactionEmailStatuses(data);
            setEmailPreferences({
                allowCustomerTransactionEmails: data.sendCustomerTransactionEmail,
                allowMerchantTransactionEmails: data.sendMerchantTransactionEmail
            });
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    };

    const set2faStatus = async (active: "yes" | "no") => {
        const payload = {
            twofa: active
        };
        try {
            const response = await client.post('subsidiary/dashboard/2fa/login/set', payload);
            const message = response?.data?.message;
            showToast(message, 'success');
            fetch2faLoginStatus()
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };


    const handleCheckboxChange = async (methodName: string, isChecked: boolean) => {
        const type = isChecked ? 'set' : 'remove';
        await setPaymentMethod(methodName, type);
    };

    const updateEmailPreferences = async (newPreferences: any) => {
        const payload = {
            subsidiaryId: activeSubsidiary?.id,
            enviromentId: envronmentDetail?.id,
            isCustomerTransactionalEmailAllowed: newPreferences.allowCustomerTransactionEmails,
            isMerchantTransactionalEmailAllowed: newPreferences.allowMerchantTransactionEmails,
        };

        try {
            const response = await client.post('subsidiary/dashboard/users/email/transaction/toggle', payload);
            const message = response?.data?.message;
            showToast(message, 'success');
            await fetchEmailTransationStatus();
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    }

    const updateLoginNotificationPreferences = async (sendLoginNotification:any) => {
        const payload = {
            loginNotification:sendLoginNotification ? "yes" :"no"
        };

        try {
            const response = await client.post('subsidiary/dashboard/login/mail/notification/set', payload);
            const message = response?.data?.message;
            showToast(message, 'success');
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    }

    const fetchSendLoginNotificationStatus = async () => {
        try {
            const response = await client.get('subsidiary/dashboard/login/mail/notification/status/get');
            const data = response.data;
            setSendLoginNotification(data.sendLoginNotification)
            
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    };

    const handleChangeLoginNotificationPreferences =(value:any)=>{
        console.log(value);
        
        setSendLoginNotification(value)
        updateLoginNotificationPreferences(value)
    }

    return (
        <div>
            <div className='grid grid-cols-1 md:grid-cols-2'>
                <div className='mx-4'>
                    <p className='text-3xl font-semibold mb-3'>Transactions</p>
                    <p className='text-sm'>Who should be charged transaction fees</p>
                </div>
                <div>
                    {feeBearer.map((bearer) => (
                        <React.Fragment key={bearer.value}>
                            <div className='flex items-center my-2 gap-4'>
                                <Checkbox
                                    checked={currentBearer?.code === bearer.value}
                                    onChange={() => setPaymentFeeBearer(bearer.value)}
                                />
                                <p className='text-sm'>{bearer.description}</p>
                            </div>
                            <hr />
                        </React.Fragment>
                    ))}

                    <div className='w-full my-4 flex justify-between'>
                        {/* <div></div>
                        <div className='flex gap-4'>
                            <button className='border px-6 py-4 rounded-lg text-md font-semibold'>Cancel</button>
                            <button className='border px-6 py-4 rounded-lg bg-custom-button-green text-md font-semibold'>Save changes</button>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2'>
                <div className='mx-4'>
                    <p className='text-3xl font-semibold mb-3'>Payment Methods</p>
                    <p className='text-sm'>Who should be charged transaction fees</p>
                </div>
                <div>
                    {paymentMethods &&
                        paymentMethods.map((method) => (
                            <div key={method.name}>
                                <div className='flex items-center my-2 gap-4'>
                                    <Checkbox
                                        checked={method.isEnabled === true}
                                        onChange={(e) => handleCheckboxChange(method.name, !method.isEnabled)}
                                    />
                                    <p className='text-sm'>Enable {method.name}</p>
                                </div>
                                <hr />
                            </div>
                        ))}

                    <div className='w-full my-4 flex justify-between'>
                        {/* <div></div>
                        <div className='flex gap-4'>
                            <button className='border px-6 py-4 rounded-lg text-md font-semibold'>Cancel</button>
                            <button className='border px-6 py-4 rounded-lg bg-custom-button-green text-md font-semibold'>Save changes</button>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2'>
                <div className='mx-4'>
                    <p className='text-3xl font-semibold mb-3'>Other preferences</p>
                </div>
                <div>
                    {twoFaStatus && (
                        <div className='flex items-center my-2 gap-4'>
                            <Checkbox checked={twoFaStatus.isTwoFAEnabled === true} onChange={() => set2faStatus(twoFaStatus.isTwoFAEnabled ? "no" : "yes")} />
                            <p className='text-sm'>Enable Two Factor Authentication for login</p>
                        </div>
                    )}

                    <div className='flex items-center my-2 gap-4'>
                        <Checkbox
                            checked={emailPreferences.allowCustomerTransactionEmails}
                            onChange={() => {
                                const newPreferences = {
                                    ...emailPreferences,
                                    allowCustomerTransactionEmails: !emailPreferences.allowCustomerTransactionEmails
                                };
                                setEmailPreferences(newPreferences);
                                updateEmailPreferences(newPreferences);
                            }}
                        />
                        <p className='text-sm'>Receive customer transactions emails</p>
                    </div>
                    <div className='flex items-center my-2 gap-4'>
                        <Checkbox
                            checked={emailPreferences.allowMerchantTransactionEmails}
                            onChange={() => {
                                const newPreferences = {
                                    ...emailPreferences,
                                    allowMerchantTransactionEmails: !emailPreferences.allowMerchantTransactionEmails
                                };
                                console.log(newPreferences);

                                setEmailPreferences(newPreferences);
                                updateEmailPreferences(newPreferences);
                            }}
                        />
                        <p className='text-sm'>Receive merchant transactions emails</p>
                    </div>
                    <div className='flex items-center my-2 gap-4'>
                        <Checkbox
                            checked={sendLoginNotification}
                            onChange={() => {
                                handleChangeLoginNotificationPreferences(!sendLoginNotification)
                            }}
                        />
                        <p className='text-sm'>Send login notification</p>
                    </div>

                    <div className='w-full my-4 flex justify-between'>
                        {/* <div></div>
                        <div className='flex gap-4'>
                            <button className='border px-6 py-4 rounded-lg text-md font-semibold'>Cancel</button>
                            <button className='border px-6 py-4 rounded-lg bg-custom-button-green text-md font-semibold hover:bg-green-700 hover:text-white' onClick={()=>updateEmailPreferences()}>Save changes</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preferences;
